import { AdminAbility } from '@repo/sdk/backoffice-abilities'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'
import { requireAdminPermission } from '@/modules/permissions/lib/require-admin-permission'
import { managedCallsQueryOptions } from './-query/query-options'

export const Route = createFileRoute('/(private)/bando')({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(
					match.context.appLanguage,
					'admin-call:calls.page_title'
				)
			}
		]
	}),
	beforeLoad: async (routeContext) => {
		await requireAdminPermission([AdminAbility.CallManage])(routeContext)
		await routeContext.context.queryClient.ensureQueryData({
			...managedCallsQueryOptions(),
			revalidateIfStale: true
		})
	},
	staticData: {
		breadcrumb: 'admin-call:calls.page_title'
	},
	component: () => <Outlet />
})
